var map = {
  "./applications.json": "92798",
  "./apps.json": "77329",
  "./attachment_relations.json": "15146",
  "./boarding.json": "87649",
  "./calendar.json": "30399",
  "./common.json": "21148",
  "./customizable_table.json": "36534",
  "./dashboard.json": "24723",
  "./job_ads.json": "12105",
  "./layouts.json": "97292",
  "./mailer.json": "40157",
  "./modules.json": "18750",
  "./news.json": "27618",
  "./payments.json": "19066",
  "./permission_presets.json": "21893",
  "./posting_orders.json": "86939",
  "./search.json": "86890",
  "./skills.json": "52543",
  "./statistics.json": "79342",
  "./support.json": "28992",
  "./time_tracking.json": "7160",
  "./wizard_settings.json": "62150"
};


function __rspack_context_module(req) {
  var id = __rspack_context_module_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_module_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context_module.keys = () => (Object.keys(map));
__rspack_context_module.resolve = __rspack_context_module_resolve;
module.exports = __rspack_context_module;
__rspack_context_module.id = 3208;
